
import Spinner from './spinner'
import Axios from 'axios'

const http = Axios.create()

function formattedDate(d) {
  const date = new Date(d)
  let month = String(date.getMonth() + 1)
  let day = String(date.getDate())
  const year = String(date.getFullYear())

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return `${day}.${month}.${year}`
}

const mailAddresses = {
  mi: 'leserfeedback@mac-and-i.de',
  ix: 'user@ix.de',
  ct: 'redaktion@ct.de',
  ch: 'mail@make-magazin.de',
  df: 'digitale-fotografie@ct.de',
  tr: 'leserbriefe@technology-review.de'
}

export default {
  name: 'purchase',
  data: function() {
    return {
      purchaseOptions: {},
      fetching: true
    }
  },
  created: function() {
    this._fetch()
  },
  props: ['articleData'],
  components: { Spinner },
  computed: {
    article: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return {}
      return this.purchaseOptions.shopArticle
    },
    freeTrial: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return {}
      return this.purchaseOptions.freeTrial
    },
    issue: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return {}
      return this.purchaseOptions.shopIssue
    },
    subscriptions: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return
      return this.purchaseOptions.subscriptions
    },
    upsell: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return {}
      return this.purchaseOptions.upsell
    },
    includedArticles: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return
      return this.purchaseOptions.includedArticles
    },
    articlesOnPage: function() {
      if (Object.keys(this.purchaseOptions).length === 0) return
      return this.purchaseOptions.articlesOnPage
    },
    loginUrl: function() {
      return '/sso/login?forward=' + window.location.href
    },
    publishingDate: function() {
      const publishingDate = this.purchaseOptions.shopArticle.publishingDate
      if (publishingDate) {
        return formattedDate(publishingDate)
      }
    },
    /* printSoldOut: function() {
     *   const publishingDate = this.purchaseOptions.shopArticle.publishingDate
     * }, */
    mailAddress: function() {
      return mailAddresses[this.articleData.magazineDbName]
    },
    mailSubject: function() {
      return this.articleData.issueName +
        ' Seite ' +
        this.articleData.page +
        ': ' +
        this.articleData.title
    },
    mailTo: function() {
      return 'mailto:' +
        encodeURI(this.mailAddress) +
        '?subject=' +
        encodeURIComponent(this.mailSubject)
    }
  },
  methods: {
    _fetch: function() {
      Promise.resolve(http.get(this.articleData.purchaseApiUrl))
        .then(response => {
          this.purchaseOptions = response.data
          this.fetching = false
          return response
        })
    },
  }
}
